import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown, Menu } from 'antd';
import menuItems from '../../../data/MenuItemsData';
import styles from './NavMenus.module.scss';

const NavMenus = () => {
  const { t } = useTranslation();

  // Render dropdown menu for "Take Action"
  const renderTakeActionMenu = (subMenu: { key: string; path: string }[]) => (
    <Menu>
      {subMenu.map((item) => (
        <Menu.Item key={item.key}>
          <Link to={item.path}>{t(`navigation.${item.key}`)}</Link>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <ul className={styles.navMenu}>
      {menuItems.map((item) => {
        if (item.subMenu) {
          // Render dropdown for "Take Action"
          return (
            <li key={item.key}>
              <Dropdown overlay={renderTakeActionMenu(item.subMenu)} placement='bottomLeft'>
                <span className={styles.dropdownLink}>
                  {t(`navigation.${item.key}`)} <span className={styles.dropdownArrow}>▼</span>
                </span>
              </Dropdown>
            </li>
          );
        }
        // Render regular menu item
        return (
          <li key={item.key}>
            <Link to={item.path}>{t(`navigation.${item.key}`)}</Link>
          </li>
        );
      })}
    </ul>
  );
};

export default NavMenus;
